import React, { useState, useEffect } from "react";
import ReportDataForm from "./ReportDataForm";
import { Paper, withStyles, CircularProgress, Dialog } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";
import * as Yup from "yup";
import * as actions from "./store/reportDataActions";
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    logo: {
        width: "250px",
        margin: "10px"
    }

});

const ReportDataCreate = props => {
    const { classes, loading, activeCustomer, onCreateReportData, onFetchLogos, translations, permissions, onFetchCustomer } = props;
    const [data, setData] = useState({ data: true, logos: [] });
    const [customerAddress, setCustomerAddress] = useState('');
    const [isLoadingCustomerAddress, setIsLoadingCustomerAddress] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            let logos = await onFetchLogos({ ActiveCustomerID: activeCustomer?.CustomerID });
            setData({ data: false, logos: logos });
        }
        fetchData();
        return () => {
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const fetchCustomer = async () => {
            const customer = await onFetchCustomer({ CustomerID: activeCustomer?.CustomerID });
            if(customer && customer.Address){
                const addressString = `${customer?.Address?.AddressLine1 ?? '-'}${customer?.Address?.AddressLine2 ? ` ${customer.Address.AddressLine2}` : ''}, ${customer?.Address?.City ?? '-'}, ${customer?.Address?.State ? `${customer.Address.State}, ` : ''}${customer?.Address?.Country ?? '-'}`;
                setCustomerAddress(addressString);
            }
            setIsLoadingCustomerAddress(false);
        }
        fetchCustomer();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async data => {
        let result = await onCreateReportData({ ...data, ActiveCustomerID: activeCustomer?.CustomerID });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        Name: "",
        CompanyName: "",
        Address: '',
        IncludePerformedDiagnoseCasesOnly: true,
        AddPhotosToErasureReports: false,
        ErasureReportPhotosLayout: '3x3',
        AddPhotosToDiagnoseReports: false,
        DiagnoseReportPhotosLayout: '3x3',
        AddPhotosToVerificationReports: false,
        VerificationReportPhotosLayout: '3x3',
        LogoID: data && data.logos instanceof Array && data.logos[0] ? data.logos[0].value : ''
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            CompanyName: Yup.string().required("Required"),
            Address: Yup.string().required("Required"),
            LogoID: Yup.string().required("Required"),
        },
        FormTitle: translations["create_report_data"] || "Create report data",
        ButtonSubmit: hasPermission(permissions, "report_data_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null,
    };

    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data.data}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }}
            >
                <AppLogoLoading />
            </Dialog>
            {!data.data && !isLoadingCustomerAddress ?
                <ReportDataForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    logos={data.logos}
                    handleSubmit={handleSubmit}
                    loading={loading}
                    translations={translations}
                    activeCustomerAddress={customerAddress}
                />
                : <CircularProgress
                    variant="static"
                    color="primary"
                    size={28}
                />}
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchLogos: (id) => dispatch(actions.fetchLogos(id)),
        onCreateReportData: ReportData => dispatch(actions.createReportData(ReportData)),
        onFetchCustomer: (params) => dispatch(actions.fetchCustomer(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ReportDataCreate));